(function () {
  /**
   * Single-open accordion: only one <details> stays open within each container.
   */
  function bindExclusiveAccordion(container) {
    if (container.dataset.acAccordionBound === 'true') return;
    container.dataset.acAccordionBound = 'true';

    const panels = container.querySelectorAll('details.ac-product-about__panel');
    if (!panels.length) return;

       panels.forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        panels.forEach((other) => {
          if (other !== details) other.removeAttribute('open');
        });
        // After sibling <details> close + layout, align viewport to accordion top (fixes stray scroll jumps).
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            container.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ac-product-about-accordion]').forEach(bindExclusiveAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
